
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import fastclick from 'fastclick'
import 'lib-flexible'
import gallery from 'img-vuer'
import moment from 'moment'
import store from './store'
import 'mint-ui/lib/style.css'
import 'iview/dist/styles/iview.css'
import 'common/stylus/index.styl'
import './common/stylus/my-mint.styl'
import iView from 'iview';
import min from './directive/min'
import max from './directive/max'
import noblank from './directive/noblank'
import required from './directive/required'
import repetition from './directive/repetition'
import number from './directive/number'
import length from './directive/length'
import VueClipboard from 'vue-clipboard2'
import WebIM from './utils/WebIM'
import timeago from './utils/timeago'

import * as filters from './common/js/filters'

import vueTap from 'v-tap';
Vue.use(vueTap);

fastclick.attach(document.body);

window.addEventListener('touchstart', function(e) { if (e.targetTouches.length === 2) { e.preventDefault(); } }, { passive: false } );

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

var VueCookie = require('vue-cookie')
Vue.use(VueCookie)
Vue.use(iView)
Vue.use(VueClipboard)
Vue.prototype.moment = moment
Vue.prototype.timeago = timeago

Vue.config.productionTip = false
Vue.use(gallery)

router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token')
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
      if (token) {  // 通过vuex state获取当前的token是否存在
          next();
      }
      else {
          next({
              path: '/login',
              query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
          })
      }
  }
  else {
      next();
  }
})

Vue.use(min)
Vue.use(max)
Vue.use(noblank)
Vue.use(required)
Vue.use(repetition)
Vue.use(number)
Vue.use(length)
Vue.use(required)

window.Vue = new Vue({
  el: '#app',
  router,
  store,
  WebIM,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js